import "./tarifsDefault.css";
import TarifsTextTitle from "./components/tarifsTextTitle";
import TarifsTextContent from "./components/tarifsTextContent";

import TarifsTextDeroulement from "./components/tarifsTextDeroulement";
import TarifsTextNotes from "./components/tarifsTextNotes";

function TarifsSoftDev() {
  const descriptionList = [
    "Nous porposons des services de développement logiciel sur mesure pour les entreprises souhaitant optimiser leurs processus, automatiser certaines tâches ou créer des outils personnalisés. En tant que développeur solo, je peux réaliser des projets variés, notamment :",
    "Applications web et mobiles : par exemple, une application de gestion des rendez-vous pour une clinique, une plateforme de suivi de commandes pour un e-commerce, ou une app mobile de suivi des interventions pour une entreprise de maintenance.",
    "Automatisation de processus : un script qui gère l'envoi automatique de factures, une solution qui extrait et organise des données depuis des emails, ou un chatbot pour répondre aux questions clients.",
    "Intégration d'API tierces : connexion à des services comme Stripe pour le paiement en ligne, Google Maps pour la géolocalisation, ou HubSpot pour synchroniser des contacts.",
    "Scripts et logiciels sur mesure : un programme de traitement de données pour un bureau d'études, un outil de veille automatisée pour un cabinet d'analyse, ou un logiciel de gestion d'adhérents pour une association.",
    "Chaque projet est adapté aux besoins spécifiques de l'entreprise afin d'assurer une solution efficace et pérenne.",
  ];
  const deroulementList = [
    "1 Devis : Une étude des besoins est réalisée afin d'établir un devis précis en fonction des fonctionnalités demandées.",
    "2 Développement : Une fois le devis validé, le développement du logiciel commence avec un suivi régulier et des points d'étape pour valider les avancements.",
    "3 Livraison : Une fois le projet terminé, le logiciel est livré avec une documentation de prise en main et, si nécessaire, une formation rapide.",
    "4 (Optionnel) Maintenance : Nous vous proposons également un service de maintenance pour assurer le bon fonctionnement du logiciel et effectuer des mises à jour si besoin.",
    "5 (Optionnel) Reprise du developpement : Si vous souhaitez rajouter de nouvelles fonctionnalités, nous pouvons établir un nouveau devis.",
  ];
  return (
    <div className="tarifs-text-main-contenair">
      <TarifsTextTitle
        title="DÉVELOPPEMENT LOGICIEL"
        price="160€ - 250€ / jour de developpement En fonction de la complexité du projet"
        atelier={true}
        domicile={false}
        time="Variable"
      />
      <div className="tarifs-text-main">
        <div className="tarifs-text-colA">
          <TarifsTextContent content={descriptionList} h="100%" />
        </div>
        <div className="tarifs-text-colB">
          <TarifsTextDeroulement operations={deroulementList} />
        </div>
      </div>
      <TarifsTextNotes notes="" />
    </div>
  );
}

export default TarifsSoftDev;
